import { render, staticRenderFns } from "./ListPph.vue?vue&type=template&id=453db14e&"
import script from "./ListPph.vue?vue&type=script&lang=js&"
export * from "./ListPph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports